export const getServerURL = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return process.env.REACT_APP_DEV_SERVER_URL as string;
    }
  }

  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_DEV_SERVER_URL as string;
  }

  return process.env.REACT_APP_PROD_SERVER_URL as string;
};
